import { render, staticRenderFns } from "./GroupActivations.vue?vue&type=template&id=6f8db158&"
import script from "./GroupActivations.vue?vue&type=script&lang=js&"
export * from "./GroupActivations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports